<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import PublicCss from '@/assets/styles/global/PublicCss.js';

export default defineComponent({
  components: {
    ...PublicCss
  },

  provide: {
    theme: ''
  },

  created() {
    // 앱 시작 시 전역 상태 복원
    this.restoreGlobalState();
  },

  methods: {
    restoreGlobalState() {
      const userInfoStr = localStorage.getItem('userInfo');
      const token = localStorage.getItem('token');

      if (userInfoStr && token) {
        try {
          const userInfo = JSON.parse(userInfoStr);

          // 기본 사용자 정보
          this.$setGlobalState('id', userInfo.user_name || userInfo.name || userInfo.id || '');
          this.$setGlobalState('manager_name', userInfo.name || '');
          this.$setGlobalState('company_name', userInfo.company || userInfo.company_name || '');
          this.$setGlobalState('company_key', userInfo.company_id || userInfo.company_key || '');

          // 바로빌 관련 정보
          this.$setGlobalState('barobill_id', userInfo.barobill_id || '');
          this.$setGlobalState('barobill_api_key', userInfo.barobill_api_key || '');

          // 팝빌 관련 정보
          this.$setGlobalState('popbill_id', userInfo.popbill_id || '');
          this.$setGlobalState('popbill_api_key', userInfo.popbill_api_key || '');

          // 더빌 관련 정보
          this.$setGlobalState('thebill_id', userInfo.thebill_id || '');
          this.$setGlobalState('thebill_api_key', userInfo.thebill_api_key || '');

          // 회사 상세 정보
          this.$setGlobalState('company_address', userInfo.company_address || '');
          this.$setGlobalState('company_bnum', userInfo.company_bnum || '');
          this.$setGlobalState('company_ceo_name', userInfo.company_ceo_name || '');
          this.$setGlobalState('company_certificate_id', userInfo.company_certificate_id || '');
          this.$setGlobalState('company_certificate_pw', userInfo.company_certificate_pw || '');
          this.$setGlobalState('company_cnum', userInfo.company_cnum || '');
          this.$setGlobalState('company_email', userInfo.company_email || '');
          this.$setGlobalState('company_fax', userInfo.company_fax || '');
          this.$setGlobalState('company_industry', userInfo.company_industry || '');
          this.$setGlobalState('company_phone', userInfo.company_phone || '');
          this.$setGlobalState('company_share_id', userInfo.company_share_id || '');
          this.$setGlobalState('company_status', userInfo.company_status || '');
          this.$setGlobalState('company_type', userInfo.company_type || '');

          // 사용자 상세 정보
          this.$setGlobalState('user_email', userInfo.user_email || '');
          this.$setGlobalState('user_phone', userInfo.user_phone || '');
          this.$setGlobalState('department', userInfo.department || '');
          this.$setGlobalState('role', userInfo.role || '');
          this.$setGlobalState('isAdmin', userInfo.isAdmin || false);

          // 기타 정보
          this.$setGlobalState('bank_info', userInfo.bank_info || '');
          this.$setGlobalState('bank_name', userInfo.bank_name || '');
          this.$setGlobalState('bank_number', userInfo.bank_number || '');
          this.$setGlobalState('bank_username', userInfo.bank_username || '');

        } catch (error) {
          console.error('전역 상태 복원 실패:', error);
        }
      }
    }
  }
});
</script>

<style>
&::-webkit-scrollbar {
  width: 8px;
}

&::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
  margin: 4px 0;
}

&::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #cbd5e1, #94a3b8);
  border-radius: 10px;
  border: 2px solid #f1f5f9;
  transition: all 0.2s ease;

  &:hover {
    background: linear-gradient(135deg, #94a3b8, #64748b);
    transform: scale(1.05);
  }

  &:active {
    background: linear-gradient(135deg, #64748b, #475569);
  }
}

&::-webkit-scrollbar-corner {
  background: #f1f5f9;
}
</style>